import * as React from 'react';
import { Paper } from '@mui/material';

// Colors here derived from: https://material-ui.com/components/snackbars/#snackbar
export type TagColor = "Red" | "Orange" | "Blue" | "Green";

export type Props = {
	text: string
	color?: TagColor
}


export default class Tag extends React.Component<Props> {
	private getBackgroundColor = () => {
		let color = this.props.color || this.getTagColor();
		switch (color) {
			case "Red": return "#f44336";
			case "Orange": return "#ff9800";
			case "Blue": return "#2196f3";
			case "Green": return "#4caf50";
		}
	}

	private getTagColor = ():TagColor => {
		switch(this.props.text) {
			case "in-production": return "Green";
			case "on-hold": return "Orange";
			case "paid": return "Green";
			case "shipped": return "Green";
			default: return "Blue";
		}
	}

	render = () => <Paper className="af-tag" style={{backgroundColor: this.getBackgroundColor()}}>{this.props.text.charAt(0).toUpperCase() + this.props.text.slice(1)}</Paper>
}